import { createI18n } from 'vue-i18n';
import de from './de';
import en from './en';
import it from './it';
import pl from './pl';
export const SUPPORTED = ['en', 'pl', 'de', 'it'];
const STORAGE_KEY = 'td-locale';
export const isLocale = (val) => (typeof val === 'string' && SUPPORTED.includes(val));
const detectInitial = () => {
    if (typeof window === 'undefined')
        return 'en';
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && isLocale(saved))
        return saved;
    const browser = window.navigator.language.slice(0, 2).toLowerCase();
    return isLocale(browser) ? browser : 'en';
};
const i18n = createI18n({
    legacy: false,
    locale: detectInitial(),
    fallbackLocale: 'en',
    messages: { en, pl, de, it },
});
export const setLocale = (locale) => {
    i18n.global.locale.value = locale;
    if (typeof window !== 'undefined') {
        window.localStorage.setItem(STORAGE_KEY, locale);
        document.documentElement.setAttribute('lang', locale);
    }
};
if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', i18n.global.locale.value);
}
export default i18n;
